import styled from "styled-components";

const Card=styled.div`

background:#20263A;
padding:22px;
border-radius:22px;

`;

const Row=styled.div`

margin-top:18px;

`;

const Bar=styled.div`

height:10px;
background:#23314b;
border-radius:999px;
overflow:hidden;

`;

const Fill=styled.div`

height:100%;
background:#34d399;

`;

export default function DiagnosisCard({

    diagnostico

}){

return(

<Card>

<h2
style={{
    color:"#F8FAFC",
    margin:0,
    fontWeight:700
}}
>
📊 Mi diagnóstico
</h2>

{

diagnostico.map(item=>(

<Row key={item.componente}>

<div
style={{
display:"flex",
justifyContent:"space-between"
}}
>

<strong
style={{
    color:"#F8FAFC"
}}
>
{item.componente}
</strong>

<strong
style={{
    color:"#6EE7B7"
}}
>
{item.dominio}%
</strong>

</div>

<Bar>

<Fill
style={{
width:`${item.dominio}%`
}}
/>

</Bar>

<div
style={{
marginTop:6,
fontSize:13,
color:"#94A3B8"
}}
>

{item.tendencia}

</div>

</Row>

))

}

</Card>

);

}